<!-- banner section -->
<section class="banner-sec">
  <div class="container-fluid p-0">
    <img loading="eager" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/banner.webp" srcset="
        https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/banner-small.webp 600w,
        https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/banner-medium.webp 1200w,
        https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/banner.webp 2000w"
      sizes="(max-width: 600px) 600px, (max-width: 1200px) 1200px, 2000px" alt="GHRCACS, PUNE | Raisoni Education"
      class="img-fluid banner-img" />
  </div>
  <div class="breadcrumb-bottom-img">
    <img loading="lazy"
      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.webp"
      alt="GHRCACS, PUNE | Raisoni Education" class="img-fluid" />
  </div>
</section>

<!-- <section class="banner-sec-main">
  <div class="sec-img-1"></div>
  <div class="sec-img-2"></div>
  <div class="sec-img-3"></div>
  <div class="container">
      <div class="banner-sm">
          <div class="row  row-cols-1 row-cols-lg-2 row-cols-md-2 align-items-center justify-content-between">
              <div class="col">
                  <div class="banner-heading">
                      <h1 class="primary-purple">Exclusive
                      <span class="playfair-display fst-italic">Privileges,
                  </span>   Just for<span class="playfair-display fst-italic">  You!</span>
                      </h1>
                      <p>A special treat this Women's Day! Unlock big savings on top brands and make every purchase count with Raisoni Privilege.

                      </p>
                  </div>
                  <a href="https://privilege.raisoni.net/login" class="cmn-button cmn-btn">Grab Your Discounts
                      Now</a>
                  <div class="banner-flex my-4 mt-lg-5">
                      <div class="banner-box right-line">
                          <h4 class="playfair-display fst-italic">Up to 15% off </h4>
                          <p>on 450+ Brands</p>
                      </div>
                      <div class="banner-box right-line">
                          <h4 class="playfair-display fst-italic">Hassle-free </h4>
                          <p>one-tap access to deals</p>
                      </div>
                      <div class="banner-box">
                          <h4 class="playfair-display fst-italic">Savings </h4>
                          <p>on your everyday essentials & luxury buys</p>
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="banner-img">
                      <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/raisoni-privilage/banner-img.png" alt="Programs"
                          class="img-fluid" />
                  </div>
              </div>
          </div>
          <div class="brand-logo">
              <div class="container">
                  <div class="border-gradient bg-white">
                      <div class="row align-items-center">
                          <div class="col-md-5">
                              <div class="sec-title mb-0">
                                  <h2 class="mb-0 fs-2">EXPLORE THE <br> MOST-LOVED BRANDS</h2>
                              </div>
                          </div>
                          <div class="col-md-7">
                              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/raisoni-privilage/brands-logo.png" alt="GHRCACS, PUNE" class="w-100">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section> -->
<!-- counter section -->
<section class="section-lg counter-sec pb-lg-0 mt-2">
  <div class="container">
    <div
      class="row row-cols-lg-4 gy-3 row-cols-md-4 row-cols-2 gx-lg-4 justify-content-lg-evenly justify-content-between mx-auto">
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 primary-purple">42<span class="primary-purple h2">+</span></h3>
          <p>Years of Innovation<br> &amp; Success </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 primary-purple">13</h3>
          <p>Educational<br> Institutes </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 primary-purple">4</h3>
          <p>Distinguished Universities </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 primary-purple">200 <span class="primary-purple h2">+</span></h3>
          <p>Courses </p>
        </div>
      </div>
      <div class=" col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 primary-purple d-inline">50000
            <span class="primary-purple h2">+</span>
          </h3>
          <p>Students</p>
        </div>
      </div>
    </div>
    <!-- <div class="bottom-border mt-4"></div> -->
  </div>
</section>
<!-- courses section -->
<section class="section-md explore-course-sec">
  <div class="container">
    <div class="row justify-content-between align-items-center">
      <div class="col col-auto">
        <div class="sec-title">
          <h2>Explore <span>Our Courses</span></h2>
        </div>
      </div>
    </div>
    <div class="bottom-border"></div>
    <div class="row justify-content-between align-items-center">
      <div class="col-auto">
        <div class="sec-subtitle">
          <h4 class="fw-bold">Under Graduate Programs <span>(08)</span></h4>
        </div>
      </div>
    </div>
    <div class="owl-carousel owl-theme" id="courses">
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/it.webp" alt="B.Sc in (AI-ML) | GHRCACS, PUNE"
              class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black">B.Sc <br> (AI-ML)</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/" class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-administration.webp"
              alt="Bachelor of Business Administration | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black">Bachelor of Business Administration</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/ug-bachelor-of-business-administration"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-computer.webp"
              alt="B.Sc. Computer Science | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black"> B.Sc. Computer <br> Science</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/ug-bachelor-of-science-computer-sciencen"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-management.webp"
              alt="BBA(Computer Application) | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black">BBA(Computer Application)</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a
                routerLink="/ug-bachelor-of-business-administration-computer-application" class="cmn-white-button">Learn
                More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-commerce.webp"
              alt="Bachelor of Commerce | GHRCACS, PUNE" class="w-100" />

          </div>
          <div class="program-details">
            <div class="d-flex  justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black"> Bachelor of Commerce</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/ug-bachelor-of-commerce"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/it.webp" alt="B.Sc(Information Technology) | GHRCACS, PUNE"
              class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black"> B.Sc(Information Technology)</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/bsc-Information-technology"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/data.webp" alt="BBA(International Business) | GHRCACS, PUNE"
              class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black">BBA(International Business)</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/bba-international-business"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/master-of-commerce.webp" alt="BCA (Science) | GHRCACS, PUNE"
              class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black">BCA <br> (Science)</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>3 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/bsc-computer-aplication"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="owl-nav"></div>
    <div class="row justify-content-between align-items-center">
      <div class="col-auto">
        <div class="sec-subtitle">
          <h4 class="fw-bold">Post Graduate Programs <span>(02)</span></h4>
        </div>
      </div>
    </div>
    <div class="owl-carousel owl-theme" id="courses1">
      <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-administration.webp"
              alt="Master of Commerce | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black">Master of Commerce</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/m-com" class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/master-of-science.webp" alt="Master of Science | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black">Master of <br> Science</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/pg-msc" class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div> -->
      <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/master-of-commerce.webp"
              alt="M.Sc Computer Science | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black"> M.Sc Computer <br> Science</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/msc-computer-science"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- upcoming event section -->
<section class="news-sec section-lg event-sec">
  <div class="container">
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-3 col-xxl-2">
        <div class="sec-title  text-center">
          <h2>Upcoming<span> Events</span></h2>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="text-center">
          <h2>No Upcoming Events</h2>
        </div>
      </div>
      <!-- <div class="col-lg-9 col-md-12">
        <div class="owl-carousel owl-theme " id="upcoming-news">

         <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/upcoming-events/2026/coffee-cup-meet.webp"
                  alt="Upcoming event | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">
                <div class="news-date d-flex mb-2 align-items-center"><i
                    class="fa fa-calendar-o primary-orange"></i><span class="ms-2"> 24<sup>th</sup> January  2026</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5> Coffee Cup Meet on Saturday 24th January  2026.</h5>
                </div>
              </div>
            </div>
          </div>
            <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/upcoming-events/2026/tech-talk.webp"
                  alt="Upcoming event | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">
                <div class="news-date d-flex mb-2 align-items-center"><i
                    class="fa fa-calendar-o primary-orange"></i><span class="ms-2"> 24<sup>th</sup> January  2026</span></div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>"Tech Talk" on Saturday 24th January  2026.</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</section>
<!-- events section -->
<section class="section-md bg-purple-light event-sec">
  <div class="container">
    <div class="sec-title text-center">
      <h2>Our <span>Events</span></h2>
      <p>Empowering Engagement</p>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="owl-carousel owl-theme" id="events">
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/industry-connect.webp"
                  alt="Industry Connect 2025 | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Industry Connect 2025</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>19th
                    July 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna.webp"
                  alt="Punyatithi of Saahitya Ratna Annabhau Sathe | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Punyatithi of Saahitya Ratna Annabhau Sathe 2025</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>18th
                    July 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/women-empowerment.webp"
                  alt="Women Empowerment program | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Women Empowerment Program 2025</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>17th
                    July 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima.webp"
                  alt="Gurupornima Celebration | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Gurupornima Celebration 2025</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>10th
                    July 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi21.webp"
                  alt="Ashadhi Ekadashi Celebration | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Ashadhi Ekadashi Celebration</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>
                    July 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/founders-day51.webp"
                  alt="Founder's Day | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Founder's Day</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>
                    June 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ghrcacs-sanskrutik-21.webp"
                  alt="kala sanskrutik Mohotsav | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> kala sanskrutik Mohotsav</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>
                    June 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/shivaji-maharaj-jayanti1.webp"
                  alt="Shivaji Maharaj Jayanti | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Shivaji Maharaj Jayanti</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>
                    21st Feb 2025</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/code-rush1.webp"
                  alt="CodeRush@Raisoni 2K25 competition | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> CodeRush@Raisoni 2K25 competition</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>
                    24th Feb 2025</span></div>
              </div>
            </div>
          </div>
          <!-- <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/novofest-24.webp"
                  alt="NovoFest 2024 | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> NovoFest 2024</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>December
                    2024</span></div>
              </div>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/diwali-mela.webp"
                  alt="Diwali Mela | GHRCACS, PUNE" class="w-100"></div>
              <div class="event-details">
                <h4> Diwali Mela</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>26
                    October 2024</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/vad-vivaad.webp" alt="Vaad Vivad competition | GHRCACS, PUNE"
                  class="w-100">
              </div>
              <div class="event-details">
                <h4> Vaad Vivad competition</h4>
                <div class="event-date"><i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i><span>16
                    October 2024</span></div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/Financial-Literacy-ghuest-lectur3.webp"
                  alt="Guest Lecture | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Guest Lecture</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>09 september 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/seminar-on-ragging.webp"
                  alt="Seminar on Ragging in college | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Seminar on Ragging in college</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>12 Aug 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/cyber-security.webp"
                  alt="Seminar on cyber security | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Seminar on cyber security</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>09 Aug 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/induction-program.webp"
                  alt="Induction Program | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Induction Program</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>08 Aug 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/Teacher's-day.webp"
                  alt="Teachers Day | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Teachers Day</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>05 september 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/guest-lecture.webp"
                  alt="Guest Lecture | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Guest Lecture</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>29 August 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/sports-event.webp"
                  alt="International sports day | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  International sports day</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>29 August 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/events.webp"
                  alt="Alumni Meet Samamvay | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Alumni Meet Samamvay</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>05 April 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/freshers-party.webp"
                  alt="Freshers party | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>Freshers party</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>05 April 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/sports.webp" alt="Sports | GHRCACS, PUNE"
                  class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Sports</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>05 April 2024</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="event-card">
              <div class="event-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/teachersday1.webp"
                  alt="Teachers Day | GHRCACS, PUNE" class="w-100" />
              </div>
              <div class="event-details">
                <h4>
                  Teachers Day</h4>
                <div class="event-date">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span>05 April 2024</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="text-center position-relative">
      <a routerLink="/events" class="cmn-white-button">View More Events</a>
    </div>
  </div>
</section>
<!-- news section -->
<section class="news-sec section-lg event-sec">
  <div class="container">
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-3 col-xxl-2">
        <div class="sec-title text-lg-start text-center">
          <h2>Our <span> Latest <br> News</span></h2>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="owl-carousel owl-theme" id="news">
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/news/mahila-sabalikaran.webp"
                  alt="Mahila Sabalikaran | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">
                <div class="news-date d-flex align-items-center mb-3">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">21 July 2025</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>Mahila Sabalikaran</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/news/news-24-nov.webp"
                  alt="Job Fair | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">
                <div class="news-date d-flex align-items-center mb-3">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">28 Nov 2024</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>Job Fair </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/latest-news.webp"
                  alt="Voter Education and Electrol Participation Programme (SVEEP) | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">
                <div class="news-date d-flex align-items-center mb-3">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">19 Nov 2024</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>Voter Education </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/apva5.webp"
                  alt="APAV workshop | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">

                <div class="news-date mb-3 d-flex align-items-center">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">12 Sept 2024</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5> APAV workshop</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/industrial-visit1.webp"
                  alt="Industrial Visit | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">

                <div class="news-date mb-3 d-flex align-items-center">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">04 Jan 2022</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5> Industrial Visit</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy" src="{{baseUrl}}/labs/guest-lecture1.webp" alt="guest-lecture | GHRCACS, PUNE"
                  class="img-fluid">
              </div>
              <div class="news-details">

                <div class="news-date mb-3 d-flex align-items-center">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2"> 30 Dec 2021</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5> Guest Lectures</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy" src="{{baseUrl}}/labs/nhrc1.webp" alt="NHRC | GHRCACS, PUNE" class="img-fluid">
              </div>
              <div class="news-details">

                <div class="news-date mb-3 d-flex align-items-center">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">Dec 2018</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>NHRC</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="news-card">
              <div class="news-img">
                <img loading="lazy" src="{{baseUrl}}/labs/taost-master1.webp" alt="Toast Master | GHRCACS, PUNE"
                  class="img-fluid">
              </div>
              <div class="news-details">

                <div class="news-date mb-3 d-flex align-items-center">
                  <i class="fa fa-calendar-o primary-orange" aria-hidden="true"></i>
                  <span class="ms-2">29 Jan 2019</span>
                </div>
                <div class="sec-thirdtitle w-auto text-start">
                  <h5>Toast Master</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center position-relative">
      <a routerLink="/latest-news" class="cmn-button">View More</a>
    </div>
  </div>
</section>
<!-- placement section -->
<!-- <section class="section-md placements-sec">
  <div class="container">
    <div class="row row-cols-lg-2 g-0 justify-content-between">
      <div class="col-lg-2">
        <div class="sec-title text-center text-lg-start">
          <h2>Our<span> Recruters</span></h2>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="owl-carousel owl-theme" id="recruiters">
          <div class="item">
            <div class="row g-2 row-cols-md-4 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/acadamy.webp" alt="acadamy | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/adobe.webp" alt="adobe | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/amazon.webp" alt="amazon | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/analytics.webp" alt="analytics | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/ashok.webp" alt="ashok | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="assets/images/recruiters/benz.webp" alt="benz | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/bosch.webp" alt="bosch | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/brightstone.webp" alt="brightstone | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/btwise.webp" alt="btwise | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/capg.webp" alt="capg | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/cumins.webp" alt="cumins | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/cyrange.webp" alt="cyrange | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/erson.webp" alt="erson | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/excellon.webp" alt="excellon | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/globallogic.webp" alt="globallogic | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/godrej.webp" alt="godrej | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/infinity.webp" alt="infinity | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/infocept.webp" alt="infocept | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/justdail.webp" alt="justdail | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/kratin.webp" alt="kratin | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/life.webp" alt="life | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/marvell.webp" alt="marvell | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/mphasis.webp" alt="mphasis | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/nice.webp" alt="nice | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/novatech.webp" alt="novatech | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/ntt.webp" alt="ntt | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/persistance.webp" alt="persistance | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/phenix.webp" alt="phenix | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/samsung.webp" alt="samsung | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/smartdata.webp" alt="smartdata | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/sokrati.webp" alt="sokrati | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/syntel.webp" alt="syntel | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/tatatech.webp" alt="tatatech | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/tcs.webp" alt="tcs | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/tech.webp" alt="tech | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/think&amp;learn.webp" alt="think learn | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/transril.webp" alt="transril | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/triveni.webp" alt="triveni | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/videocon.webp" alt="videocon | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/zenstar.webp" alt="zenstar | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/h.webp" alt="h | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/hirect.webp" alt="hirect | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/IBM.webp" alt="IBM | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/sokrati.webp" alt="sokrati | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row g-2 g-lg-4">
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/wipro.webp" alt="wipro | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/icici_bank.webp" alt="icici_bank | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/IBM.webp" alt="IBM | GHRCACS, PUNE">
                </div>
              </div>
              <div class="col">
                <div class="recruters-card">
                  <img loading="lazy" class="img-fluid" src="{{baseUrl}}/recruiters/sokrati.webp" alt="sokrati | GHRCACS, PUNE">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<section class="section-lg pt-0 placements-sec">
  <div class="container">
    <div class="gradient-separator"></div>
    <div class="row row-cols-lg-3 m-lg-5 justify-content-between align-items-center">
      <div class="col-lg-4">
        <div data-aos="fade-up" class="sec-title">
          <h2 class="mb-3">Impeccable <span>Placements</span></h2>
          <p class="text-md-start m-auto text-center  text-dark ">Education That Goes Where Your Dreams Will Not Take
            You</p>
        </div>
        <article>
          <div class="marquee">
            <ul class="marquee__group recruters-list">
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/persistent.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/accenture.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/delta.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sterlite.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/dxc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/adani.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/amazon.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ambuja-cement.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/apollo-tyres.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ashok-layland.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-allianz.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bosch.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-finserv.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/capgemini.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/cognizant.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/conexant.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/essar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/gmmco.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/godrej.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ibm.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/icici-bank.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infocepts.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosprectrum.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ispat.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/itc-infotech.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jio.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jsw.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kirloskar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kone.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/l&amp;t-infotech.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/larsen-toubro.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mahindara.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mico.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mk-schomburg.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/oracle.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance-info.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sasken.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reva.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sintex.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/soma.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sterlite.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tech-mahindra.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ultratech-cement.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/wipro.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/zensar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
            </ul>
            <ul aria-hidden="true" class="marquee__group recruters-list">
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/persistent.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/accenture.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/delta.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sterlite.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/dxc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/adani.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/amazon.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ambuja-cement.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/apollo-tyres.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ashok-layland.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-allianz.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bosch.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-finserv.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/capgemini.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/cognizant.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/conexant.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/essar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/gmmco.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/godrej.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ibm.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/icici-bank.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infocepts.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosprectrum.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ispat.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/itc-infotech.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jio.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jsw.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kirloskar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kone.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/l&amp;t-infotech.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/larsen-toubro.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mahindara.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mico.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mk-schomburg.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/oracle.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance-info.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sasken.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reva.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sintex.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/soma.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sterlite.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tech-mahindra.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ultratech-cement.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/wipro.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
              <li class="recruters-card"><img loading="lazy"
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/zensar.webp"
                  alt="Recruiters | GHRCACS, PUNE" title="Recruiters"></li>
            </ul>
          </div>
        </article>
      </div>
      <div class="col-lg-8">
        <div class="grid-item place-img">
          <img loading="lazy"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/placements/GauriGajananTodkar.webp"
            alt="placement | GHRCACS, PUNE" class="w-25">
          <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/placement.webp"
            alt="placement | GHRCACS, PUNE" class="w-25">
          <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/placement1.webp"
            alt="placement | GHRCACS, PUNE" class="w-25">
          <img loading="lazy"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/std-achivements/std-achivements.webp"
            alt="placement | GHRCACS, PUNE" class="w-25">
          <img loading="lazy"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/std-achivements/mahesh-shrimant-patil.webp"
            alt="placement | GHRCACS, PUNE" class="w-25">
        </div>
      </div>
    </div>
    <div class="gradient-separator"></div>
  </div>
</section>
<!-- gallery section -->
<section class="section-md campus-infra-sec">
  <div class="kimba-1">
    <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/kimba/kimba-1.webp"
      alt="Kimba | GHRCACS, PUNE">
  </div>
  <div class="container">
    <div class="sec-title text-center">
      <h2> Student <span>Life & Campus Infrastructure</span></h2>
      <p>Creating Spaces for Growth and Well-being</p>
    </div>
    <div class="grid-container">
      <div class="grid-item1">
        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/life.webp "
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" />

      </div>
      <div class="grid-item2 d-inline-block">
        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/sport.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE">

        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/lab.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" class="ms-1" />

        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/bus.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" />

      </div>
      <div class="grid-item3 ">
        <img loading="lazy"
          src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/classroom.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" class="h-100" />

      </div>
      <div class="grid-item4">
        <img loading="lazy"
          src="	https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/hostel.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" />

        <img loading="lazy"
          src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/library.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" />

      </div>
      <div class="grid-item5">
        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/campus.webp"
          alt="Life & Campus Infrastructure | GHRCACS, PUNE" />
      </div>
    </div>
  </div>
</section>
<!-- testimonials section -->
<section class="testimonial-sec section-xs bg-purple-light">
  <div class="container">
    <div class="sec-title text-center">
      <h2><span>Our Testimonials</span></h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-9 col-md-12">
        <div class="owl-carousel owl-theme" id="testimonials">
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center">
                <div class="col-md-3">
                  <div class="testimonials-img">

                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/muskaan_rathod.webp"
                        alt="muskaan_rathod | GHRCACS, PUNE">
                    </div>

                  </div>
                </div>
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p>The college provides us with good education and has excellent infrastructure. The faculty members
                    are well qualified and co-operative. Along with education, a plethora of activities including
                    seminars, workshops, guest lectures, competitions are organized to groom the students.</p>
                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">MUSKAAN RATHOD</h5>
                    <h6>SY B.B.A</h6>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center">
                <div class="col-md-3">
                  <div class="testimonials-img">

                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/rohit_diwar.webp"
                        alt="rohit_diwar | GHRCACS, PUNE">
                    </div>

                  </div>
                </div>
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>

                  <p>My past 3 years as the student of Bachelor program has been promising and growth-centric at the
                    college. I owe this to the college staff, including the Head of the Department, the Vice Principal
                    and the Principal. The staff members have always been there to clear the doubts and answer the
                    questions. The environment of the college is amazing and has the best of the facilities.</p>

                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">ROHIT DHIWAR</h5>
                    <h6>TY B.Com</h6>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center">
                <div class="col-md-3">
                  <div class="testimonials-img">

                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/shreehari_shelke.webp"
                        alt="shreehari_shelke | GHRCACS, PUNE">
                    </div>

                  </div>
                </div>
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>

                  <p>Life without thankfulness is devoid of love and passion and silent gratitude isn’t much use to
                    anyone. So I take this opportunity to extend my gratitude to my college and placement department for
                    chiseling my career and sparing their precious time in kindling our talents. Reflecting on all that
                    I am grateful to my college is eternal. The GHRCACS, Pune is the destination and dream of a secure
                    future.</p>

                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">Shreehari Shelke</h5>
                    <h6>TY B.Sc.</h6>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center">
                <div class="col-md-3">
                  <div class="testimonials-img">

                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/jyotsana_kumari.webp"
                        alt="jyotsana_kumari | GHRCACS, PUNE">
                    </div>

                  </div>
                </div>
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>

                  <p>My life at Raisoni College made me stronger and took me a step ahead for being independent. I am
                    thankful to all the professors who supported us and corrected us throughout our Bachelor program. I
                    love the infrastructure of the RGI Pune campus and its refreshing surroundings. The many numbers of
                    events I participated in has helped in the growth of my confidence level.</p>

                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">Jyotsana Kumari </h5>
                    <h6>TY B.Sc.</h6>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center">
                <div class="col-md-3">
                  <div class="testimonials-img">

                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/vishal_bhosle.webp"
                        alt="vishal_bhosle | GHRCACS, PUNE">
                    </div>

                  </div>
                </div>
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>

                  <p>G H Raisoni College of Arts, Commerce and Science is one of the most renowned colleges in Pune. The
                    ambience is soothing and calm. The teaching staff is accessible to the students all the time and the
                    HODs and Principal have always been the best motivators. The college does have many numbers of
                    activities organized as a part of their curriculum.</p>

                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">Vishal Bhosle</h5>
                    <h6>SY BCA</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center flex-row-reverse">
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p>The college campus is well equipped with facilities including swimming pool, seminar hall, 2
                    canteens, library, sports grounds, gymnasium, and restrooms on each floor. Apart from this, we the
                    students are provided with training and placements at every level of education. In fact, we also
                    have career guidance programs in different sectors including Banking, Finance and the Competitive
                    examinations.</p>
                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">Anjali Shivale </h5>
                    <h6>SY B.B.A</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="testimonials-img">
                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/anjali_shivale.webp"
                        alt="anjali_shivale | GHRCACS, PUNE">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonials">
              <div class="row row-cols-1 align-items-center flex-row-reverse">
                <div class="col-md-9">
                  <div class="quote">
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <svg width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.7541 3C1.11606 17.638 1.81311 30.882 4.60137 34.7157C7.38963 38.5495 11.2234 39.2465 14.7086 38.898C24.0721 37.9617 29.3466 20.7747 14.0115 19.3806"
                        stroke="#ffa502" stroke-opacity="0.2" stroke-width="6" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p>My past 3 years as the student of Bachelor program has been promising and growth-centric at the
                    college. I owe this to the college staff, including the Head of the Department, the Vice Principal
                    and the Principal. The staff members have always been there to clear the doubts and answer the
                    questions. The environment of the college is amazing and has the best of the facilities.</p>
                  <div class="sec-thirdtitle">
                    <h5 class="text-uppercase">Abhishek Sayakar</h5>
                    <h6>TY B.Sc.</h6>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="testimonials-img">
                    <div class="testi-img">
                      <img loading="lazy" src="{{baseUrl}}/testimonials/abhishek_sayakar.webp"
                        alt="abhishek_sayakar | GHRCACS, PUNE">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- alumni section -->
<section class="section-lg alumni-sec">
  <div class="container">
    <div class="sec-title m-auto text-center">
      <h2>Alumni<span> Community</span></h2>
      <p>Strengthening Alumni Ties for Success</p>
    </div>
    <div class="grid-container">
      <div class="grid-item1">
        <div class="alumni-card"
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/akash-yevale.webp);">
          <div class="alumni-details">
            <h5>Aakash Yevale</h5>
            <p>
              Bachelor of Business Administration, Commerce
              2016 - 2020
              Sales Officer
              Hdfc bank
            </p>
          </div>
        </div>
      </div>
      <div class="grid-item2">
        <div class="alumni-card "
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/chaitanya-lokhande.webp);">
          <div class="alumni-details">
            <h5>Chaitanya Lokhande
            </h5>
            <p>
              Master of Science, Computer Science
              2022 - 2024
              Marketing Technology Automation Executive
              Springer Nature
            </p>
          </div>
        </div>
        <div class="alumni-card "
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/community/pooja.webp);">
          <div class="alumni-details">
            <h5>Pooja Akhoury</h5>
            <p>Radio Compliance Test Engineer at Microsoft, Redmond, Washington, United States</p>
          </div>
        </div>
      </div>
      <div class="grid-item3">
        <div class="alumni-card"
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/riya-chauhan.webp);">
          <div class="alumni-details">
            <h5>Riya Chauhan
            </h5>
            <p>
              M.Sc, Computer Science
              2022 - 2024
              Software Engineer Trainee
              Cognizant Technology Solutions India Pvt. Ltd
            </p>
          </div>
        </div>
      </div>
      <div class="grid-item4">
        <div class="alumni-card "
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/snehal-thele.webp);">
          <div class="alumni-details">
            <h5>Snehal Thele
            </h5>
            <p>
              Bachelor of Science, Computer Science
              2019 - 2022
              Software Engineer (Q.A.)
              Capgemini Consulting India Pvt Ltd
            </p>
          </div>
        </div>
        <div class="alumni-card "
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/community/aniruddha.webp);">
          <div class="alumni-details">
            <h5>Aniruddha Barahate</h5>
            <p>Process Engineer at Central California Almond Growers Assn, Fresno, California,
              United States</p>
          </div>
        </div>
      </div>
      <div class="grid-item5">
        <div class="alumni-card"
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/prasad-gawade.webp);">
          <div class="alumni-details">
            <h5>Prasad Gawade
            </h5>
            <p>
              Bachelor of Computer Applications, BCA
              2021 - 2024
              Market Research Analyst
              Demand infotech solutions
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-between row-cols-2 mt-4">
      <div class="col-3 text-start position-relative ">
        <img loading="lazy"
          src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/proudly-raisonian.webp"
          alt="proudly raisonian | GHRCACS, PUNE">
      </div>
      <div class="col-8 ">
        <p>Step into the legacy of excellence at Raisoni Education, where your journey is empowered,
          your story is valued, and your achievements make you a proud Raisonian.</p>
      </div>
    </div>
    <div class="text-center">
      <a href="https://alumni.raisoni.net/" target="_blank" class="cmn-white-button">View More</a>
    </div>
  </div>
</section>
<!-- kimba section -->
<section class="section-sm">
  <div class="container">
    <div class="gradient-separator"></div>
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-4 col-md-5 col-8 offset-lg-1">
        <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/kimba/kimba.webp"
          alt="Kimba | GHRCACS, PUNE" class="img-fluid w-100">
      </div>
      <div class="col-lg-4 col-md-7 offset-lg-1  text-center text-lg-start">
        <div class="sec-title">
          <h2> Our <span>Mascot Kimba</span></h2>
          <p class="mb-0">Raisonians! Gear Up,</p>
          <p>Kimba is now on his pawsome adventures!</p>
        </div>
        <h6 class="fw-600 text-dark">Raisonians, the most awaited moments is Here
          Kimba is now on his pawsome adventures!</h6>
        <a href="kimba" class="cmn-white-button  mb-3">View Profile</a>
      </div>
    </div>
    <div class="gradient-separator"></div>
  </div>
</section>
<!-- raisoni world section -->
<section class="section-lg">
  <div class="container">
    <div class="sec-title text-center">
      <h2> Connect, <span>Share, and Explore</span></h2>
      <p>Find us on Instagram - #raisoniworld</p>
    </div>
    <div class=" col-12">
      <div class="widget-box">
        <div class="widget-box-inner">
          <iframe src="https://www.instagram.com/raisoniworld/embed" frameborder="0" scrolling="no"
            allowtransparency="">
          </iframe>
        </div>
        <div class="text-center">
          <a href="#" class="cmn-white-button  mt-0 mb-3">View Profile</a>
        </div>
      </div>
    </div>
  </div>
</section>

<app-popup-modal></app-popup-modal>
